// Import dependency
import cookie from 'js-cookie';

// Append authorization token to API calls
export function tokenize(data) {
  var dataObject = data ? data : {};

  dataObject.token = cookie.get('token');
  dataObject.headers = { token: cookie.get('token') };
  return dataObject;
}

// If a user is already logged in, direct them to the appropriate screen
export function checkTokenIfLoggedIn() {
  var token = cookie.get('token');
  var user_type = cookie.get('user-type');

  if (token) {
    if (user_type === 'member') {
      // If user logged in is a member, re-direct them to the videos menu
      window.location.href = '/videos';
    } else if (user_type === 'admin') {
      // IF user logged in is an admin, re-direct them to the login history page
      window.location.href = '/admin/history';
    }
  }
}

// Given the number of bytes, return a string in GB/MB etc
export function bytesToString(size) {
  if (size > 1024000000)
    return (((size / (1024)) / 1024) / 1024).toFixed(2) + "GB";
  else
    return ((size / 1024) / 1024).toFixed(1) + "MB";
}